import { useNavigation } from "@react-navigation/native";
import { useState } from "react";
import {
    StyleSheet,
    Text,
    View,
    Pressable,
    Image,
    ScrollView,
    SafeAreaView,
    TextInput,
} from "react-native";
import { BaseButton } from "../components/BaseButton";
import { BaseInput } from "../components/BaseInput";
import { BaseLargeText } from "../components/BaseLargeText";
import { colors } from "../constants/colors";
import { registerUserWithEmailAndPassword, signInUserWithEmailAndPassword } from "../services/firebase/auth_email";

export default function WelcomeScreen() {
    const navigation = useNavigation();

    return (<View style={{ flex: 1, backgroundColor: colors.brightBlue, padding: 20 }}>
        <View style={{ height: '30%' }} />
        <Image
            style={{ width: 300, height: 40, alignSelf: 'center', marginBottom: 60 }}
            source={require('../assets/logo.png')} />
        <BaseButton text="Logi sisse" containerStyle={{ backgroundColor: colors.darkPurple, marginTop: 20, shadowColor: colors.darkPurple }} textStyle={{ color: 'white' }} onPress={() => navigation.navigate('Log in')} medium />
        <BaseButton text="Registreeri" containerStyle={{ backgroundColor: colors.darkPurple, marginTop: 20, shadowColor: colors.darkPurple }} textStyle={{ color: 'white' }} onPress={() => navigation.navigate("Register")} medium />
    </View>)

}
